
import { PostgrestFilterBuilder } from '@supabase/postgrest-js';
import { TravelConstraints, filterCountriesByTravelConstraints, getCountriesWithinTravelConstraints } from '../mappings/TravelDistanceMapping';

export const applyTravelDistanceFilter = (
  query: any,
  constraints: TravelConstraints
): any => {
  console.log('🛫 === APPLYING TRAVEL DISTANCE FILTER ===');
  console.log('Travel constraints:', constraints);

  // Get all countries that match the travel constraints
  const allowedCountries = getCountriesWithinTravelConstraints(constraints);
  
  if (allowedCountries.length === 0) {
    console.log('❌ No countries match the travel constraints');
    return query.eq('country', 'IMPOSSIBLE_MATCH'); // Return no results
  }

  console.log(`✅ Found ${allowedCountries.length} countries within travel constraints:`, allowedCountries);

  // Apply country filter
  let filteredQuery = query.in('country', allowedCountries);
  
  // NEW: Apply transport type filter based on preferences
  if (constraints.preferFlying) {
    console.log('✈️ User prefers flying - filtering for flight vacations');
    // Filter for vacations that include flights or are flight-based
    filteredQuery = filteredQuery.or(
      'transportType.ilike.%vliegtuig%,transportType.ilike.%vlucht%,transportType.ilike.%fly%,transportType.ilike.%flight%,specialCategories.ilike.%vliegreis%,specialCategories.not.ilike.%autoreis%'
    );
  } else if (constraints.preferDriving) {
    console.log('🚗 User prefers driving - filtering for car vacations');
    // Filter for vacations that are car-based or don't specify flights
    filteredQuery = filteredQuery.or(
      'transportType.ilike.%auto%,transportType.ilike.%car%,specialCategories.ilike.%autoreis%,transportType.is.null'
    );
  }
  
  console.log('🎯 Applied travel distance and transport preference filters');
  return filteredQuery;
};

export const getTravelDistanceMessage = (constraints: TravelConstraints): string => {
  const messages = [];
  
  if (constraints.maxFlightHours) {
    messages.push(`maximaal ${constraints.maxFlightHours} uur vliegen`);
  }
  
  if (constraints.maxDrivingHours) {
    messages.push(`maximaal ${constraints.maxDrivingHours} uur rijden`);
  }
  
  if (constraints.maxDrivingKm) {
    messages.push(`maximaal ${constraints.maxDrivingKm} km rijden`);
  }
  
  if (constraints.preferDriving) {
    messages.push('bereikbaar met de auto');
  }
  
  if (constraints.preferFlying && !constraints.maxFlightHours) {
    messages.push('vliegbestemming');
  }

  return messages.length > 0 ? messages.join(' en ') : 'reisvoorkeur';
};
